import { Component, inject } from '@angular/core';
import { OAuthService } from 'angular-oauth2-oidc';
import { ButtonSettings } from 'src/app/models/button-settings.model';
import { ContentCardComponent } from '../../modules/shared-modules/content-card/content-card.component';
import { CustomButtonComponent } from '../../modules/shared-modules/custom-button/custom-button.component';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss'],
    imports: [ContentCardComponent, CustomButtonComponent]
})
export class LoginComponent {
  private oauthService = inject(OAuthService);


  public buttonSettings: ButtonSettings = {
    fontIcon: 'login',
    label: 'Login'
  }

  submit() {
    this.oauthService.initImplicitFlow();
  }

}
